import { Button } from '@/shared/ui';

import styles from './AuthFailed.module.scss';

interface AuthFailedProps {
  message: string | null;
  onRetry: () => void;
}

export function AuthFailed({ message, onRetry }: AuthFailedProps) {
  return (
    <div className={styles.wrapper} data-testid="auth-failed">
      <h1 className={styles.title}>Не удалось войти</h1>
      <p className={styles.message}>
        {message ??
          'Открой игру через бота BetBoom и попробуй снова.'}
      </p>
      <Button onClick={onRetry}>Попробовать снова</Button>
    </div>
  );
}
